/* tl-cachebust-20260814-dup-price */
/**
 * Titanoré board buy-box — pan-matching ATC.
 * EN: Add to cart · NL: In winkelwagen
 * Self-mounts on board PDP if theme template cache is stale.
 * Owns the only price row — hides theme .shop-product-price-* when present.
 */
(function () {
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test((location.pathname || '').toLowerCase())) return;
  var VARIANT_ID = 57831485833603;

  function isBoardPdp() {
    var path = location.pathname || '';
    if (/cutting-board-bundle|board-bundle/i.test(path)) return false;
    if (document.getElementById('tl-board-buybox')) return true;
    if (document.body && /benefit-board/i.test(document.body.className || '') && !/bundle/i.test(document.body.className || '')) return true;
    return /titanium-cutting-board-shop|titanium-cutting-board(?!-bundle)|snijplank/i.test(path);
  }

  function currentLang() {
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === 'function') {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return 'nl';
    var m = document.cookie.match(/(?:^|; )wglang=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : 'en';
  }

  function applyI18n(root) {
    var key = currentLang() === 'nl' ? 'nl' : 'en';
    (root || document).querySelectorAll('[data-en][data-nl]').forEach(function (el) {
      var next = el.getAttribute('data-' + key) || el.getAttribute('data-en');
      if (next != null) el.textContent = next;
    });
  }

  
  function rewriteNativeButtons() {
    var label = currentLang() === 'nl' ? 'In winkelwagen' : 'Add to cart';
    document.querySelectorAll('button, a, span, div').forEach(function (el) {
      var t = (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) ? (el.textContent || '').trim() : '';
      if (!t) return;
      if (/^(Add to [Cc]art|SHOP NOW|In winkelwagen|Toevoegen aan winkelwagen)$/.test(t)) {
        if (el.closest && el.closest('#tl-board-buybox')) return;
        /* sticky / native */
        if (el.classList && (el.classList.contains('button-text') || /sticky/i.test(el.className||'') || el.closest('.sticky-add-to-cart'))) {
          el.textContent = label;
        }
      }
    });
    document.querySelectorAll('.sticky-add-to-cart .button-text, .sticky-add-to-cart button, .sticky-add-to-cart .button').forEach(function (el) {
      if (el.classList.contains('button-text') || el.matches('button, .button')) {
        if (el.classList.contains('button-text') || (el.childNodes.length && el.querySelector('.button-text')==null && el.children.length===0)) {
          el.textContent = label;
        } else {
          var bt = el.querySelector('.button-text');
          if (bt) bt.textContent = label;
        }
      }
    });
  }

  function syncStickyLabel() {
    var label = currentLang() === 'nl' ? 'In winkelwagen' : 'Add to cart';
    document.querySelectorAll('.sticky-add-to-cart .button-text').forEach(function (el) {
      el.textContent = label;
    });
    /* Force pan sticky look if old SHOP NOW black style still cached */
    var style = document.getElementById('tl-board-sticky-match');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tl-board-sticky-match';
      style.textContent =
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart,body.template-suffix-benefit-board-v4 .sticky-add-to-cart,' +
        'body.template-product.template-suffix-benefit-board-v3 .sticky-add-to-cart,body.template-product.template-suffix-benefit-board-v4 .sticky-add-to-cart{' +
        'background:#1c2b1e!important}' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart button,body.template-suffix-benefit-board-v4 .sticky-add-to-cart button,' +
        'body.template-suffix-benefit-board-v3 .sticky-add-to-cart .button,body.template-suffix-benefit-board-v4 .sticky-add-to-cart .button{' +
        'background:#6b1d28!important;color:#ffffff!important;border-radius:8px!important;' +
        'font-size:15px!important;font-weight:650!important;letter-spacing:.01em!important;' +
        'text-transform:none!important;min-height:48px!important;border:0!important;padding:14px 20px!important}' +
        'body.template-suffix-benefit-board-v3 .shop-product-info,body.template-suffix-benefit-board-v4 .shop-product-info button[name="add"],' +
        'body.template-suffix-benefit-board-v3 .shop-product-info,body.template-suffix-benefit-board-v4 .shop-product-info .product-form__submit,' +
        'body.template-suffix-benefit-board-v3 .shop-product-info,body.template-suffix-benefit-board-v4 .shop-product-info [class*="add-to-cart"]:not(#tl-board-buybox):not(#tl-board-buybox *),' +
        'body.template-suffix-benefit-board-v3 .product-form__submit,' +
        'body.template-suffix-benefit-board-v3 button[name="add"],' +
        'body.template-suffix-benefit-board-v3 [class*="selluxe"],' +
        'body.template-suffix-benefit-board-v3 .shopify-payment-button{display:none!important}' +
        'body.template-suffix-benefit-board-v3 #tl-board-buybox,.tl-board-buybox{display:block!important}';
      document.head.appendChild(style);
    }
  }

  function mountBuybox() {
    if (document.getElementById('tl-board-buybox')) return document.getElementById('tl-board-buybox');
    if (!isBoardPdp()) return null;

    var host =
      document.querySelector('.shop-product-info') ||
      document.querySelector('[class*="product-info"]') ||
      document.querySelector('product-info') ||
      document.querySelector('main .product');
    if (!host) return null;

    var box = document.createElement('div');
    box.id = 'tl-board-buybox';
    box.className = 'tl-board-buybox';
    box.setAttribute('data-variant-id', String(VARIANT_ID));
    box.innerHTML =
      '<div class="tl-buybox-head">' +
      '<p class="tl-size-line" data-en="Layered titanium · One board" data-nl="Gelagerd titanium · Één board">Layered titanium · One board</p>' +
      '<p class="tl-promise" data-en="Non-porous. Dishwasher safe. Built for daily prep." data-nl="Niet-poreus. Vaatwasserbestendig. Gemaakt voor dagelijkse prep.">Non-porous. Dishwasher safe. Built for daily prep.</p>' +
      '</div>' +
      '<div class="tl-price" aria-live="polite">' +
      '<span class="tl-price-now">€94</span>' +
      '<span class="tl-price-was">€157</span>' +
      '<span class="tl-price-off" data-en="40% SUMMER DISCOUNT" data-nl="40% ZOMERKORTING">40% SUMMER DISCOUNT</span>' +
      '</div>' +
      '<button type="button" class="tl-cta" data-cta data-en="Add to cart" data-nl="In winkelwagen">Add to cart</button>' +
      '<p class="tl-trust" data-en="Free returns · Juice channel · No PFAS / PFOA / PTFE coating" data-nl="Gratis retour · Sapgoot · Geen PFAS / PFOA / PTFE-coating"><strong>Free returns</strong> · Juice channel · No PFAS / PFOA / PTFE coating</p>';

    var anchor =
      host.querySelector('.price, [class*="product-price"], [class*="Price"]') ||
      host.querySelector('form[action*="/cart/add"]') ||
      host;
    if (anchor && anchor.parentNode) {
      if (anchor.matches('form') || /cart\/add/i.test(anchor.getAttribute('action') || '')) {
        anchor.parentNode.insertBefore(box, anchor);
      } else {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
    } else {
      host.appendChild(box);
    }
    return box;
  }

  function wire(root) {
    if (!root || root.getAttribute('data-wired') === '1') return;
    root.setAttribute('data-wired', '1');
    var cta = root.querySelector('[data-cta]');
    if (!cta) return;

    function setBusy(busy) {
      cta.disabled = !!busy;
      if (busy) {
        cta.setAttribute('data-prev', cta.textContent || '');
        cta.textContent = currentLang() === 'nl' ? 'Bezig…' : 'Adding…';
      } else {
        var prev = cta.getAttribute('data-prev');
        if (prev) cta.textContent = prev;
        applyI18n(root);
      }
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.disabled) return;
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          window.location.href = '/products/titanium-cutting-board?variant=' + VARIANT_ID;
        });
    });
  }

  function boot() {
    if (!isBoardPdp()) return;
    var root = document.getElementById('tl-board-buybox') || mountBuybox();
    if (root) {
      applyI18n(root);
      wire(root);
    }
    /* Buybox owns price — hide theme price block entirely (fixes duplicate €94) */
    try {
      if (document.getElementById('tl-board-buybox')) {
        var host =
          document.querySelector('.shop-product-info') ||
          document.querySelector('[class*="product-info"]');
        if (host) {
          host
            .querySelectorAll(
              '.shop-product-price-container, .shop-product-price-block, .shop-compare-price, .shop-save-price, .price, [class*="product-price"], [class*="Price"]'
            )
            .forEach(function (el) {
              if (el.closest && el.closest('#tl-board-buybox')) return;
              el.style.display = 'none';
              el.setAttribute('aria-hidden', 'true');
            });
        }
      }
      /* Deduplicate multiple .tl-price-off nodes */
      var offs = document.querySelectorAll('.tl-price-off, .tl-summer-chip');
      var seen = {};
      offs.forEach(function (el) {
        var key = (el.textContent || '').trim();
        if (!key) return;
        if (seen[key]) el.style.display = 'none';
        else seen[key] = 1;
      });
    } catch (e) {}
    syncStickyLabel(); rewriteNativeButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 600);
  setTimeout(boot, 1600);

  try {
    if (window.Weglot && typeof Weglot.on === 'function') {
      Weglot.on('languageChanged', function () {
        var root = document.getElementById('tl-board-buybox');
        if (root) applyI18n(root);
        syncStickyLabel(); rewriteNativeButtons();
      });
    }
  } catch (e) {}
})();
